import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import '../styles/library.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus, faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';
const db = firebase.firestore();

const PdfViewerModal = ({ pdf, user, onClose }) => {
  const [campaigns, setCampaigns] = useState([]);
  const [showCampaignPicker, setShowCampaignPicker] = useState(false);
  const [addedTo, setAddedTo] = useState({});

  useEffect(() => {
    if (!user?.uid) return;
    db.collection('campaigns')
      .where('idUserDm', '==', user.uid)
      .where('active', '==', true)
      .get()
      .then(snap => {
        const camps = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setCampaigns(camps);
        const alreadyAdded = {};
        (pdf.campaignIds || []).forEach(id => { alreadyAdded[id] = true; });
        camps.forEach(c => {
          const key = c.uid || c.id;
          if (alreadyAdded[key] === undefined && alreadyAdded[c.id]) alreadyAdded[key] = true;
        });
        setAddedTo(alreadyAdded);
      });
  }, [user]);

  const addToCampaign = async (campaignId, campaignUid) => {
    const key = campaignUid || campaignId;
    await db.collection('campaignLibrary').doc(key)
      .collection('docs').doc(pdf.id).set({
        pdfId: pdf.id,
        title: pdf.title,
        type: pdf.type,
        authorName: pdf.authorName,
        url: pdf.url,
        addedAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
    await db.collection('library').doc(pdf.id).update({
      campaignIds: firebase.firestore.FieldValue.arrayUnion(key),
    });
    setAddedTo(prev => ({ ...prev, [key]: true }));
    toast.success(i18next.t('library.addedToCampaign'));
  };

  const removeFromCampaign = async (campaignId, campaignUid) => {
    const key = campaignUid || campaignId;
    await db.collection('campaignLibrary').doc(key).collection('docs').doc(pdf.id).delete();
    await db.collection('library').doc(pdf.id).update({
      campaignIds: firebase.firestore.FieldValue.arrayRemove(key),
    });
    setAddedTo(prev => ({ ...prev, [key]: false }));
    toast.success(i18next.t('library.removedFromCampaign'));
  };

  return (
    <div className="pdfViewerOverlay">
      <div className="pdfViewerHeader">
        <div className="pdfViewerMeta">
          <span className={`libraryCardType libraryCardType--${pdf.type}`}>
            {i18next.t(`library.types.${pdf.type}`)}
          </span>
          <h2 className="pdfViewerTitle">{pdf.title}</h2>
          <span className="pdfViewerAuthor">{pdf.authorName}</span>
          {pdf.description && <p className="pdfViewerDesc">{pdf.description}</p>}
        </div>
        <div className="pdfViewerActions">
          {campaigns.length > 0 && (
            <div className="pdfCampaignPicker">
              <button
                className="pdfAddToCampaignBtn"
                onClick={() => setShowCampaignPicker(!showCampaignPicker)}
              >
                <FontAwesomeIcon icon={faPlus} />
                {i18next.t('library.addToCampaign')}
              </button>
              {showCampaignPicker && campaigns.length > 0 && (
                <div className="pdfCampaignDropdown">
                  {campaigns.map(c => {
                    const key = c.uid || c.id;
                    const added = addedTo[key];
                    return (
                      <button
                        key={c.id}
                        className={`pdfCampaignOption${added ? ' added' : ''}`}
                        onClick={() => added ? removeFromCampaign(c.id, c.uid) : addToCampaign(c.id, c.uid)}
                      >
                        {added
                          ? <><FontAwesomeIcon icon={faMinus} /> {c.name}</>
                          : <>{c.name}</>
                        }
                      </button>
                    );
                  })}
                </div>
              )}
              {showCampaignPicker && campaigns.length === 0 && (
                <div className="pdfCampaignDropdown">
                  <span className="pdfCampaignEmpty">{i18next.t('library.noCampaigns')}</span>
                </div>
              )}
            </div>
          )}
          <button className="pdfViewerClose" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>
      <iframe
        className="pdfViewerFrame"
        src={pdf.url}
        title={pdf.title}
      />
    </div>
  );
};

export default PdfViewerModal;
